// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__N0q5Y","modal":"Modal_modal__Xjqdl","slide-down":"Modal_slide-down__PLuwo"};